import { render, staticRenderFns } from "./MediaItemRestriction.vue?vue&type=template&id=683487bc&scoped=true&"
import script from "./MediaItemRestriction.vue?vue&type=script&lang=js&"
export * from "./MediaItemRestriction.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./MediaItemRestriction.vue?vue&type=style&index=1&id=683487bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683487bc",
  null
  
)

export default component.exports